<div class="w-full mx-auto flex flex-col p-4 sm:p-6 max-md:p-0 max-md:gap-3 gap-6 min-h-screen">
  <!-- Filter Controls -->
  <div
    class="w-full flex flex-col gap-4 p-4 md:p-1 bg-white rounded-lg border-input-field-stroke max-md:p-0 max-md:gap-3">
    <div class="w-full flex flex-col justify-start items-start gap-4 max-md:gap-2">
      <!-- Orders Heading -->
      <div class="w-full flex flex-col justify-start items-start gap-1">
        <div class="text-black text-2xl font-bold leading-8 max-md:text-xl">
          Orders
          <span class="text-black md:hidden">& Returns</span>
          <span class="text-gray-500 max-md:text-lg md:hidden">
            - {{ (selectedOrderStatuses.length > 0 || selectedTimeFilter || searchTerm) ? filteredOrders.length :
            countOrders }} Products</span>
        </div>
      </div>

      <!-- Filter and Controls Row - Horizontal on desktop, vertical on mobile -->
      <div class="w-full flex justify-between items-center max-md:flex-col max-md:gap-4">
        <!-- Tabs - Left side on desktop -->
        <div
          class="p-1 bg-[#DFEBFB] rounded-lg flex items-center gap-2 w-fit md:w-auto max-md:w-full max-md:justify-center max-md:flex-wrap"
          data-property-1="ver 1">
          <!-- All Tab -->
          <div (click)="selectTab('all')" [class]="
              'w-[91px] h-8 px-2 rounded justify-center items-center gap-2 flex cursor-pointer transition-colors max-md:flex-1 ' +
              (selectedTab === 'all' ? 'bg-[#307FE1]' : 'hover:bg-blue-100')
            ">
            <div [class]="
                'text-base font-bold leading-6 max-md:text-sm ' +
                (selectedTab === 'all' ? 'text-white' : 'text-black')
              ">
              All
            </div>
          </div>

          <!-- Active Tab -->
          <!-- <div
            (click)="selectTab('active')"
            [class]="
              'w-[91px] h-8 px-2 rounded justify-center items-center gap-2 flex cursor-pointer transition-colors max-md:flex-1 ' +
              (selectedTab === 'active' ? 'bg-[#307FE1]' : 'hover:bg-blue-100')
            "
          >
            <div
              [class]="
                'text-base font-bold leading-6 max-md:text-sm ' +
                (selectedTab === 'active' ? 'text-white' : 'text-black')
              "
            >
              Active
            </div>
          </div> -->

          <!-- Completed Tab -->
          <div (click)="selectTab('completed')" [class]="
              'w-[91px] h-8 px-2 rounded justify-center items-center gap-2 flex cursor-pointer transition-colors max-md:flex-1 ' +
              (selectedTab === 'completed'
                ? 'bg-[#307FE1]'
                : 'hover:bg-blue-100')
            ">
            <div [class]="
                'text-base font-bold leading-6 max-md:text-sm ' +
                (selectedTab === 'completed' ? 'text-white' : 'text-black')
              ">
              Completed
            </div>
          </div>

          <!-- Booking Tab -->
          <div (click)="selectTab('booking')" [class]="
              'w-[91px] h-8 px-2 rounded justify-center items-center gap-2 flex cursor-pointer transition-colors max-md:flex-1 ' +
              (selectedTab === 'booking'
                ? 'bg-[#307FE1]'
                : 'hover:bg-blue-100')
            ">
            <div [class]="
                'text-base font-bold leading-6 max-md:text-sm ' +
                (selectedTab === 'booking' ? 'text-white' : 'text-black')
              ">
              Booking
            </div>
          </div>

          <div (click)="selectTab('enquiry')" [class]="
              'w-[91px] h-8 px-2 rounded justify-center items-center gap-2 flex cursor-pointer transition-colors max-md:flex-1 ' +
              (selectedTab === 'enquiry'
                ? 'bg-[#307FE1]'
                : 'hover:bg-blue-100')
            ">
            <div [class]="
                'text-base font-bold leading-6 max-md:text-sm ' +
                (selectedTab === 'enquiry' ? 'text-white' : 'text-black')
              ">
              Enquiry
            </div>
          </div>
        </div>

        <!-- Right Controls: Search + Filters - Right side on desktop -->
        <div class="flex items-center justify-end gap-4 max-md:flex-col max-md:w-full max-md:gap-4">
          <!-- Search Box - Full width on mobile, positioned at top -->
          <div
            class="w-[228px] h-8 px-2 rounded-md border border-[#D4D4D4] flex items-center justify-between bg-white max-md:w-full max-md:h-10 max-md:px-3">
            <input [(ngModel)]="searchTerm"
              [placeholder]="selectedTab === 'booking' ? 'Search by Booking Number' : selectedTab === 'enquiry' ? 'Search by Enquiry Number' : 'Search by Invoice Number'"
              class="flex-1 text-sm font-medium leading-5 text-black placeholder-[#777777] bg-transparent outline-none"
              (keyup)="onSearchEnter($event)" />
            <ng-container *ngIf="!searched">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"
                (click)="searchOrders()" class="cursor-pointer">
                <path
                  d="M13.8807 13.8807C16.4842 11.2772 16.4842 7.05612 13.8807 4.45262C11.2772 1.84913 7.05612 1.84913 4.45262 4.45262C1.84913 7.05612 1.84913 11.2772 4.45262 13.8807C7.05612 16.4842 11.2772 16.4842 13.8807 13.8807ZM13.8807 13.8807L17.5 17.5"
                  stroke="#777777" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </ng-container>
            <ng-container *ngIf="searchTerm.trim() && searched">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="none"
                (click)="clearSearch()" class="cursor-pointer ml-2">
                <path d="M6 6L14 14M6 14L14 6" stroke="#777777" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </ng-container>
          </div>

          <!-- Filter Row - Side by side on mobile, below search -->
          <div class="flex gap-3 max-md:w-full justify-between">
            <!-- Order Type Dropdown -->
            <div class="flex-1 min-w-0 relative" data-device="Web" data-dropdown-container>
              <div (click)="toggleOrderTypeDropdown()"
                class="h-8 py-1 px-3 bg-white rounded-lg border border-[#D4D4D4] flex items-center justify-between gap-1 cursor-pointer hover:border-gray-400 transition-colors focus:outline-none max-md:flex-1 max-md:h-10 max-md:py-2 min-w-[120px]">
                <span class="text-black text-sm font-medium leading-5 whitespace-nowrap">
                  {{ getOrderTypeDisplayText() }}
                </span>
                <div class="flex items-center gap-1">
                  <ng-container *ngIf="selectedOrderStatuses.length > 0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="none"
                      (click)="resetOrderStatus(); $event.stopPropagation()" class="cursor-pointer">
                      <path d="M6 6L14 14M6 14L14 6" stroke="#777777" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                    </svg>
                  </ng-container>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"
                    [class.rotate-180]="showOrderTypeDropdown">
                    <path d="M5 7.5L9.41074 11.9107C9.73618 12.2362 10.2638 12.2362 10.5893 11.9107L15 7.5"
                      stroke="black" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
              </div>

              <!-- Custom Dropdown Panel -->
              <div *ngIf="showOrderTypeDropdown"
                class="absolute right-0 top-full mt-2 bg-white rounded-lg border border-[#D4D4D4] shadow-lg z-40 min-w-[260px] max-md:min-w-[250px] max-md:left-0 max-md:right-auto overflow-hidden"
                (click)="$event.stopPropagation()">
                <!-- Product Type Section -->
                <!-- <div class="px-4 pt-4 pb-3 border-b border-[#D4D4D4]">
                 <div class="flex justify-between items-center mb-3">
                      <div class="text-black text-sm font-medium">
                        Product Type
                      </div>
                      <button (click)="resetProductType()"
                        class="text-[#307FE1] text-sm font-medium hover:underline cursor-pointer">
                        Reset
                      </button>
                    </div> 
                   <div class="flex gap-4">
                    <label class="flex items-center gap-2 cursor-pointer">
                      <input type="radio" name="productType" value="both" [checked]="selectedProductType === 'both'"
                        (change)="selectProductType('both')"
                        class="w-4 h-4 text-[#307FE1] border-gray-300 focus:ring-[#307FE1] focus:ring-2 cursor-pointer" />
                      <span class="text-black text-sm font-medium">Both</span>
                    </label>
                    <label class="flex items-center gap-2 cursor-pointer">
                      <input type="radio" name="productType" value="Used Parts"
                        [checked]="selectedProductType === 'Used Part'" (change)="selectProductType('Used Part')"
                        class="w-4 h-4 text-[#307FE1] border-gray-300 focus:ring-[#307FE1] focus:ring-2 cursor-pointer" />
                      <span class="text-black text-sm font-medium">Parts</span>
                    </label>
                    <label class="flex items-center gap-2 cursor-pointer">
                      <input type="radio" name="productType" value="Scrap Parts"
                        [checked]="selectedProductType === 'Scrap Part'" (change)="selectProductType('Scrap Part')"
                        class="w-4 h-4 text-[#307FE1] border-gray-300 focus:ring-[#307FE1] focus:ring-2 cursor-pointer" />
                      <span class="text-black text-sm font-medium">Scrap</span>
                    </label>
                  </div>
                </div> -->

                <!-- Order Status Section -->
                <div class="px-4 pt-4 pb-4 rounded-b-lg">
                  <div class="flex justify-between items-center mb-3">
                    <div class="text-black text-sm font-medium">
                      Order Status
                    </div>
                    <button (click)="resetOrderStatus()"
                      class="text-[#307FE1] text-sm font-medium hover:underline cursor-pointer">
                      Reset
                    </button>
                  </div>
                  <div class="flex flex-col gap-0">
                    <label class="flex items-center gap-2 py-1 border-b border-[#D4D4D4] cursor-pointer">
                      <input type="checkbox" [checked]="
                          selectedOrderStatuses.includes('Out for Delivery')
                        " (change)="toggleOrderStatus('Out for Delivery')"
                        class="w-4 h-4 text-[#307FE1] border-gray-300 rounded focus:ring-[#307FE1] focus:ring-2 cursor-pointer" />
                      <span class="text-black text-sm font-medium">Out for delivery</span>
                    </label>
                    <label class="flex items-center gap-2 py-1 border-b border-[#D4D4D4] cursor-pointer">
                      <input type="checkbox" [checked]="selectedOrderStatuses.includes('Delivered')"
                        (change)="toggleOrderStatus('Delivered')"
                        class="w-4 h-4 text-[#307FE1] border-gray-300 rounded focus:ring-[#307FE1] focus:ring-2 cursor-pointer" />
                      <span class="text-black text-sm font-medium">Delivered</span>
                    </label>
                    <label class="flex items-center gap-2 py-1 border-b border-[#D4D4D4] cursor-pointer">
                      <input type="checkbox" [checked]="
                          selectedOrderStatuses.includes('Order Cancelled')
                        " (change)="toggleOrderStatus('Order Cancelled')"
                        class="w-4 h-4 text-[#307FE1] border-gray-300 rounded focus:ring-[#307FE1] focus:ring-2 cursor-pointer" />
                      <span class="text-black text-sm font-medium">Order Cancelled</span>
                    </label>
                    <label class="flex items-center gap-2 py-1 border-b border-[#D4D4D4] cursor-pointer">
                      <input type="checkbox" [checked]="
                          selectedOrderStatuses.includes('Return Requested')
                        " (change)="toggleOrderStatus('Return Requested')"
                        class="w-4 h-4 text-[#307FE1] border-gray-300 rounded focus:ring-[#307FE1] focus:ring-2 cursor-pointer" />
                      <span class="text-black text-sm font-medium">Return Requested</span>
                    </label>
                    <label class="flex items-center gap-2 py-1 cursor-pointer">
                      <input type="checkbox" [checked]="selectedOrderStatuses.includes('Picked Up')"
                        (change)="toggleOrderStatus('Picked Up')"
                        class="w-4 h-4 text-[#307FE1] border-gray-300 rounded focus:ring-[#307FE1] focus:ring-2 cursor-pointer" />
                      <span class="text-black text-sm font-medium">Picked Up</span>
                    </label>
                    <label class="flex items-center gap-2 py-1 cursor-pointer">
                      <input type="checkbox" [checked]="
                          selectedOrderStatuses.includes('Refund Pending')
                        " (change)="toggleOrderStatus('Refund Pending')"
                        class="w-4 h-4 text-[#307FE1] border-gray-300 rounded focus:ring-[#307FE1] focus:ring-2 cursor-pointer" />
                      <span class="text-black text-sm font-medium">Refund Pending</span>
                    </label>
                    <label class="flex items-center gap-2 py-1 cursor-pointer">
                      <input type="checkbox" [checked]="
                          selectedOrderStatuses.includes('Refund Credited')
                        " (change)="toggleOrderStatus('Refund Credited')"
                        class="w-4 h-4 text-[#307FE1] border-gray-300 rounded focus:ring-[#307FE1] focus:ring-2 cursor-pointer" />
                      <span class="text-black text-sm font-medium">Refund Credited</span>
                    </label>
                    <label class="flex items-center gap-2 py-1 cursor-pointer">
                      <input type="checkbox" [checked]="selectedOrderStatuses.includes('Shipped')"
                        (change)="toggleOrderStatus('Shipped')"
                        class="w-4 h-4 text-[#307FE1] border-gray-300 rounded focus:ring-[#307FE1] focus:ring-2 cursor-pointer" />
                      <span class="text-black text-sm font-medium">Shipped</span>
                    </label>

                    <label class="flex items-center gap-2 py-1 cursor-pointer">
                      <input type="checkbox" [checked]="selectedOrderStatuses.includes('In-Transit')"
                        (change)="toggleOrderStatus('In-Transit')"
                        class="w-4 h-4 text-[#307FE1] border-gray-300 rounded focus:ring-[#307FE1] focus:ring-2 cursor-pointer" />
                      <span class="text-black text-sm font-medium">In-Transit</span>
                    </label>
                  </div>
                </div>
              </div>

              <!-- Backdrop to close dropdown -->
              <div *ngIf="showOrderTypeDropdown" class="fixed inset-0 z-30" (click)="showOrderTypeDropdown = false"
                style="background: transparent; pointer-events: auto"></div>
            </div>

            <!-- Time Dropdown -->
            <div class="flex-1 min-w-0 relative" data-device="Web" data-time-dropdown-container>
              <div (click)="toggleTimeDropdown()"
                class="h-8 py-1 px-3 bg-white rounded-lg border border-[#D4D4D4] flex items-center justify-between gap-2 cursor-pointer hover:border-gray-400 transition-colors max-md:flex-1 max-md:h-10 max-md:py-2 min-w-[100px]">
                <span class="text-black text-sm font-medium leading-5 whitespace-nowrap">
                  {{ getTimeFilterDisplayText() }}
                </span>
                <div class="flex items-center gap-1">
                  <ng-container *ngIf="selectedTimeFilter">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="none"
                      (click)="resetTimeFilter(); $event.stopPropagation()" class="cursor-pointer">
                      <path d="M6 6L14 14M6 14L14 6" stroke="#777777" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                    </svg>
                  </ng-container>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"
                    [class.rotate-180]="showTimeDropdown">
                    <path d="M5 7.5L9.41074 11.9107C9.73618 12.2362 10.2638 12.2362 10.5893 11.9107L15 7.5"
                      stroke="black" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
              </div>

              <!-- Custom Time Dropdown Panel -->
              <div *ngIf="showTimeDropdown"
                class="absolute right-0 top-full mt-2 bg-white rounded-lg border border-[#D4D4D4] shadow-lg z-40 min-w-[160px] max-md:min-w-full overflow-hidden"
                (click)="$event.stopPropagation()">
                <div class="flex flex-col">
                  <div (click)="selectTimeFilter('thisMonth')"
                    class="px-4 py-2 border-b border-[#D4D4D4] cursor-pointer hover:bg-gray-50 transition-colors">
                    <span class="text-black text-sm font-medium">This Month</span>
                  </div>
                  <div (click)="selectTimeFilter('lastMonth')"
                    class="px-4 py-2 border-b border-[#D4D4D4] cursor-pointer hover:bg-gray-50 transition-colors">
                    <span class="text-black text-sm font-medium">Last Month</span>
                  </div>
                  <div (click)="selectTimeFilter('last6Month')"
                    class="px-4 py-2 border-b border-[#D4D4D4] cursor-pointer hover:bg-gray-50 transition-colors">
                    <span class="text-black text-sm font-medium">Last 6 Month</span>
                  </div>
                  <div (click)="selectTimeFilter('2025')"
                    class="px-4 py-2 border-b border-[#D4D4D4] cursor-pointer hover:bg-gray-50 transition-colors">
                    <span class="text-black text-sm font-medium">2025</span>
                  </div>
                  <div (click)="selectTimeFilter('2024')"
                    class="px-4 py-2 border-b border-[#D4D4D4] cursor-pointer hover:bg-gray-50 transition-colors">
                    <span class="text-black text-sm font-medium">2024</span>
                  </div>
                  <div (click)="selectTimeFilter('2023')"
                    class="px-4 py-2 cursor-pointer hover:bg-gray-50 transition-colors">
                    <span class="text-black text-sm font-medium">2023</span>
                  </div>
                </div>
              </div>

              <!-- Backdrop to close dropdown -->
              <div *ngIf="showTimeDropdown" class="fixed inset-0 z-30" (click)="showTimeDropdown = false"
                style="background: transparent; pointer-events: auto"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Order Cards -->
  <div *ngFor="let order of filteredOrders"
    class="w-full mr-3 max-md:mr-0 overflow-hidden rounded-lg border flex flex-col">
    <!-- Order Header -->
    <div
      class="w-full p-3 bg-neutrals-off-white flex justify-between items-center max-md:grid max-md:grid-cols-2 max-md:gap-y-2 max-md:items-start">
      <!-- Invoice and Status -->
      <div class="w-48 flex flex-col gap-1 max-md:w-full" *ngIf="
          order.isBooking ||
          (order.status !== 'Payment Failed' &&
            order.status !== 'Payment Pending' &&
            order.status !== 'aborted')
        ">
        <div class="flex items-center gap-2 max-md:gap-0.5 flex-wrap">
          <div class="text-primary-deep-blue text-base font-bold max-md:text-sm">
            {{ selectedTab === "booking" ? "Booking No" : selectedTab === "enquiry" ? "Enquiry No" : "Invoice No" }}
          </div>
          <div [class]="
              'h-6 px-2 py-0.5 max-md:h-5 max-md:px-1 max-md:py-0.5 rounded-full items-center ' +
              getStatusStyles(
                (selectedTab === 'booking' || selectedTab === 'enquiry') && order.status !== 'Order Cancelled'
                  ? order.bookingStatus || order.status
                  : order.status
              )
            ">
            <div class="text-xs font-bold whitespace-nowrap max-md:text-[10px]">
              {{
              order.status === "Order Cancelled"
              ? "Order Cancelled"
              : (selectedTab === "booking" || selectedTab === "enquiry") ? (order.bookingStatus || order.status) :
              order.status
              }}
            </div>
          </div>
        </div>
        <div class="text-text-caption text-base font-bold max-md:text-sm">
          {{ order.invoiceNo }}
        </div>
        <div class="text-text-caption text-xs font-medium" *ngIf="order.isBooking && order.documentType">
          {{ getDocumentTypeLabel(order.documentType) }}
          <span *ngIf="order.orderNumber"> · {{ order.orderNumber }}</span>
        </div>
      </div>

      <div class="w-48 flex flex-col gap-1 max-md:w-full" *ngIf="
          !order.isBooking &&
          (order.status === 'Payment Failed' || order.status === 'aborted')
        ">
        <div class="flex items-center gap-2 flex-wrap">
          <div class="text-[#E30613] text-base font-bold max-md:text-sm">
            Payment Failed
          </div>
          <div [class]="'h-6 items-center '">
            <div class="text-xs font-bold whitespace-nowrap">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="24" height="24">
                <defs>
                  <linearGradient id="errorGradient" x1="16" x2="16" y1="2.888" y2="29.012"
                    gradientUnits="userSpaceOnUse">
                    <stop offset="0" stop-color="#ff624a" />
                    <stop offset=".25" stop-color="#ff5940" />
                    <stop offset=".67" stop-color="#fd4224" />
                    <stop offset="1" stop-color="#fc2c0a" />
                  </linearGradient>
                </defs>

                <!-- Circle background -->
                <circle cx="16" cy="16" r="13" fill="url(#errorGradient)" />

                <!-- White "X" -->
                <path fill="#fff" d="M17.414,16l3.288-3.288c0.391-0.391,0.391-1.024,0-1.414
                       c-0.391-0.391-1.024-0.391-1.414,0L16,14.586l-3.288-3.288
                       c-0.391-0.391-1.024-0.391-1.414,0c-0.391,0.391-0.391,1.024,0,1.414
                       L14.586,16l-3.288,3.288c-0.391,0.391-0.391,1.024,0,1.414
                       c0.391,0.391,1.024,0.391,1.414,0L16,17.414l3.288,3.288
                       c0.391,0.391,1.024,0.391,1.414,0c0.391-0.391,0.391-1.024,0-1.414
                       L17.414,16z" />
              </svg>
            </div>
          </div>
        </div>
        <div class="text-text-caption text-base font-bold max-md:text-sm">
          Server Issue of your Bank
        </div>
      </div>

      <div class="w-48 flex flex-col gap-1 max-md:w-full"
        *ngIf="!order.isBooking && order.status === 'Payment Pending'">
        <div class="flex items-center gap-2 flex-wrap">
          <div class="text-[#EB8700] text-base font-bold max-md:text-sm">
            Payment Pending
          </div>
          <div [class]="'h-6 items-center '">
            <div class="text-xs font-bold whitespace-nowrap">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="24" height="24">
                <defs>
                  <linearGradient id="pendingExclamationGradient" x1="16" x2="16" y1="2" y2="30"
                    gradientUnits="userSpaceOnUse">
                    <stop offset="0" stop-color="#FFD234" />
                    <stop offset="1" stop-color="#FFA500" />
                  </linearGradient>
                </defs>

                <!-- Circle background -->
                <circle cx="16" cy="16" r="13" fill="url(#pendingExclamationGradient)" />

                <!-- Exclamation mark -->
                <rect x="15" y="8" width="2" height="12" fill="white" rx="1" />
                <circle cx="16" cy="23" r="2" fill="white" />
              </svg>
            </div>
          </div>
        </div>
        <div class="text-text-caption text-base font-bold max-md:text-sm">
          Server Issue of your Bank
        </div>
      </div>

      <!-- Order Rating -->

      <!-- Delivery Info / Booking date -->
      <div class="w-48 flex flex-col gap-1 max-md:w-full max-md:items-end">
        <ng-container *ngIf="order.isBooking; else invoiceDelivery">
          <div class="text-primary-deep-blue text-base font-bold max-md:text-sm">
            Order Date
          </div>
          <div class="text-text-caption text-base font-bold max-md:text-sm">
            {{
            order.deliveryDate
            ? (order.deliveryDate | date: "dd MMM yyyy, hh:mm a")
            : "—"
            }}
          </div>
        </ng-container>
        <ng-template #invoiceDelivery>
          <div class="text-primary-deep-blue text-base font-bold max-md:text-sm">
            {{ order.deliveryType }}
          </div>
          <div class="text-text-caption text-base font-bold max-md:text-sm" *ngIf="
              order?.status !== 'Payment Failed' &&
              order?.status !== 'Payment Pending' &&
              order?.status !== 'aborted'
            ">
            {{
            order.deliveryType === "Home Delivery"
            ? "Delivery by"
            : "Pickup on"
            }}
            {{ order.deliveryDate | date: "dd MMM yyyy" }}
          </div>
          <div class="text-text-caption text-base font-bold max-md:text-sm" *ngIf="
              order?.status === 'Payment Failed' ||
              order?.status === 'Payment Pending' ||
              order?.status === 'aborted'
            ">
            Estimated after order
          </div>
        </ng-template>
      </div>

      <div class="w-36 flex flex-col justify-center items-start gap-1 max-md:w-full max-md:items-start"
        *ngIf="order.isBooking">
        <div class="text-primary-deep-blue text-base font-bold max-md:text-sm">
          {{ selectedTab === 'enquiry' ? 'Enquiry Amount' : 'Booking Amount' }}
        </div>
        <div class="text-text-caption text-base font-bold max-md:text-sm">
          {{ formatBookingAmount(order.bookingAmount) }}
        </div>
      </div>

      <div class="w-36 flex flex-col justify-center items-start gap-1 max-md:w-full max-md:items-start"
        *ngIf="!order.isBooking">
        <div class="text-primary-deep-blue text-base font-bold max-md:text-sm">
          Order Rating
        </div>
        <div class="text-text-caption text-base font-bold max-md:text-sm"
          *ngIf="order?.status !== 'Delivered' && order?.status !== 'Picked Up'">
          Post-Delivery
        </div>

        <button (click)="toggleRatingPopup(order)"
          class="text-secondary-blue text-base font-bold max-md:text-sm cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
          *ngIf="
            (order?.status === 'Delivered' || order?.status === 'Picked Up') &&
            order?.rating?.stars === 0
          ">
          Rate & Review
        </button>

        <div class="text-text-caption text-base font-bold max-md:text-sm"
          *ngIf="order?.status === 'Delivered' || order?.status === 'Picked Up'">
          <span *ngIf="order?.rating?.stars === 1" class="flex items-center gap-1">
            <span class="text-primary-deep-blue">
              <svg width="24" height="24" viewBox="0 0 46.6667 46.6667" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M46.6667 23.3333C46.6667 36.22 36.22 46.6667 23.3333 46.6667C10.4467 46.6667 0 36.22 0 23.3333C0 10.4467 10.4467 0 23.3333 0C36.22 0 46.6667 10.4467 46.6667 23.3333Z"
                  fill="#EE1520" />
                <path
                  d="M30.334 32.6666C30.334 32.6666 28.0007 30.3332 23.334 30.3332C18.6673 30.3332 16.334 32.6666 16.334 32.6666M11.6445 23.0725C13.5705 23.9175 17.0174 23.3098 18.5382 21.8569M28.1298 21.8568C29.6506 23.3096 33.0974 23.9174 35.0234 23.0723"
                  stroke="black" stroke-width="2.33333" stroke-linecap="round" stroke-linejoin="round" />
              </svg>

            </span>
            | Poor
          </span>

          <span *ngIf="order?.rating?.stars === 2" class="flex items-center gap-1">
            <span class="text-primary-deep-blue">
              <svg width="24" height="24" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M51.3327 28C51.3327 40.8866 40.886 51.3333 27.9993 51.3333C15.1127 51.3333 4.66602 40.8866 4.66602 28C4.66602 15.1133 15.1127 4.66663 27.9993 4.66663C40.886 4.66663 51.3327 15.1133 51.3327 28Z"
                  fill="#FFD234" />
                <path
                  d="M20.2217 22.1667C21.5102 22.1667 22.5555 23.2112 22.5557 24.4998C22.5557 25.7884 21.5103 26.8337 20.2217 26.8337C18.9332 26.8336 17.8887 25.7883 17.8887 24.4998C17.8888 23.2113 18.9333 22.1669 20.2217 22.1667ZM35.7773 22.1667C37.0659 22.1667 38.1112 23.2112 38.1113 24.4998C38.1113 25.7884 37.066 26.8337 35.7773 26.8337C34.4888 26.8336 33.4443 25.7883 33.4443 24.4998C33.4445 23.2113 34.4889 22.1669 35.7773 22.1667Z"
                  fill="black" />
                <path d="M35 37.3335H21" stroke="black" stroke-width="2.33333" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>

            </span>
            | Good
          </span>
          <span *ngIf="order?.rating?.stars === 3" class="flex items-center gap-1">
            <span class="text-primary-deep-blue">
              <svg width="24" height="24" viewBox="0 0 46.6667 46.6667" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M46.6667 23.3333C46.6667 36.22 36.22 46.6667 23.3333 46.6667C10.4467 46.6667 0 36.22 0 23.3333C0 10.4467 10.4467 0 23.3333 0C36.22 0 46.6667 10.4467 46.6667 23.3333Z"
                  fill="#36B548" />
                <path
                  d="M11.6656 18.6666C12.8322 12.8333 17.4989 12.8333 18.6656 18.6666M27.9989 18.6666C29.1656 12.8333 33.8322 12.8333 34.9989 18.6666M23.3323 37.3333C17.2366 37.3333 12.0508 33.4375 10.1289 28C10.1289 28 18.6656 29.1666 23.3323 29.1666C27.9989 29.1666 36.5357 28 36.5357 28C34.6137 33.4375 29.428 37.3333 23.3323 37.3333Z"
                  stroke="black" stroke-width="2.33333" stroke-linecap="round" stroke-linejoin="round" />
              </svg>

            </span>
            | Excellent
          </span>
        </div>
      </div>

      <!-- View Details Button -->
      <div class="flex items-center justify-end gap-2 max-md:w-full max-md:min-w-0 max-md:gap-1 max-md:justify-end">
        <button (click)="navigateToOrderDetails(order)"
          class="text-secondary-blue text-sm font-bold hover:underline whitespace-nowrap">
          View Details
        </button>
        <button type="button" (click)="toggleOrderExpanded(order)" [attr.aria-expanded]="isOrderExpanded(order)"
          [attr.aria-label]="
            isOrderExpanded(order) ? 'Collapse order' : 'Expand order'
          "
          class="p-1 rounded text-primary-deep-blue hover:bg-gray-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-secondary-blue">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"
            class="transition-transform duration-200" [class.rotate-180]="isOrderExpanded(order)">
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </button>
      </div>
    </div>

    <!-- Booking Items -->
    <div class="w-full px-3 flex justify-center items-start max-md:px-2"
      *ngIf="order.isBooking && isOrderExpanded(order)">
      <div class="flex-1 flex flex-col justify-center items-start">
        <ng-container *ngIf="isBookingItemsLoading(order); else bookingItemsLoaded">
          <div *ngFor="let _ of [1, 2]" class="w-full py-2 flex items-center gap-4 max-md:gap-2 animate-pulse"
            aria-hidden="true">
            <div class="w-[75px] h-[56px] rounded bg-gray-200"></div>
            <div class="flex-1 flex flex-col gap-2">
              <div class="h-4 w-2/3 rounded bg-gray-200"></div>
              <div class="h-3 w-1/2 rounded bg-gray-200"></div>
              <div class="h-3 w-1/4 rounded bg-gray-200"></div>
            </div>
            <div class="h-5 w-20 rounded-full bg-gray-200"></div>
          </div>
        </ng-container>

        <ng-template #bookingItemsLoaded>
          <div *ngIf="hasBookingItemsError(order)" class="w-full py-3 text-text-caption text-sm font-medium">
            Couldn't load items. Collapse and expand to retry.
          </div>

          <div *ngIf="
              !hasBookingItemsError(order) &&
              getBookingLineItems(order).length === 0
            " class="w-full py-3 text-text-caption text-sm font-medium">
            {{ selectedTab === 'enquiry' ? 'No items in this enquiry.' : 'No items in this booking.' }}
          </div>

          <div *ngFor="let item of getBookingLineItems(order)"
            class="w-full py-2 flex items-center gap-4 max-md:gap-2 max-md:flex-row">
            <img [src]="item?.part_image || 'assets/default.webp'" [alt]="item?.part_name"
              (error)="onImageError($event)" class="w-[75px] h-[56px] rounded object-cover" />

            <div class="flex-1 flex flex-col gap-1">
              <div class="text-black text-lg font-bold max-md:text-sm">
                {{ item?.part_name || item?.part_desc }}
              </div>
              <div class="text-text-caption text-sm font-medium max-md:text-xs"
                *ngIf="item?.part_desc && item?.part_name">
                {{ item?.part_desc }}
              </div>
              <div class="text-text-caption text-base font-medium max-md:text-sm">
                Qty {{ item?.quantity }} ·
                {{ formatBookingAmount(item?.total_amount) }}
              </div>
            </div>

            <!-- <div
              *ngIf="item?.order_line_status"
              [class]="
                'h-6 px-2 py-0.5 max-md:h-5 max-md:px-1 rounded-full flex items-center ' +
                getStatusStyles(item.order_line_status)
              "
            >
              <div class="text-xs font-bold whitespace-nowrap max-md:text-[10px]">
                {{ item.order_line_status }}
              </div>
            </div> -->
          </div>
        </ng-template>
      </div>
    </div>

    <!-- Order Items -->
    <div class="w-full px-3 flex justify-center items-start max-md:px-2"
      *ngIf="!order.isBooking && isOrderExpanded(order)">
      <div class="flex-1 flex flex-col justify-center items-start">

        <!-- Loading State -->
        <ng-container *ngIf="isInvoiceDetailsLoading(order); else invoiceDetailsLoaded">
          <div class="w-full py-3 flex items-center gap-4 max-md:gap-2 animate-pulse" aria-hidden="true">
            <!-- Image skeleton -->
            <div class="w-[75px] h-[56px] rounded bg-gray-200"></div>

            <!-- Content skeleton -->
            <div class="flex-1 flex flex-col gap-2">
              <div class="h-4 w-40 rounded bg-gray-200"></div>
              <div class="h-3 w-24 rounded bg-gray-200"></div>
              <div class="h-3 w-20 rounded bg-gray-200"></div>
            </div>
          </div>
        </ng-container>

        <ng-template #invoiceDetailsLoaded>

          <!-- Error -->
          <div *ngIf="hasInvoiceDetailsError(order)" class="w-full py-3 text-text-caption text-sm font-medium">
            Couldn't load invoice details.
            Collapse and expand to retry.
          </div>

          <!-- No Data -->
          <div *ngIf="
          !hasInvoiceDetailsError(order) &&
          getInvoiceDetails(order).length === 0
        " class="w-full py-3 text-text-caption text-sm font-medium">
            No invoice details found.
          </div>

          <!-- Individual Invoice Items -->
          <div *ngFor="let item of getInvoiceDetails(order)"
            class="w-full py-2 flex items-center gap-4 max-md:gap-2 max-md:flex-row">

            <!-- Product Image -->
            <img [src]="item?.part_image || 'assets/default.webp'" [alt]="item?.part_desc || 'Product'"
              (error)="onImageError($event)" class="w-[75px] h-[56px] rounded object-cover" />

            <!-- Product Information -->
            <div class="flex-1 flex flex-col gap-1">

              <!-- Part Description -->
              <div class="text-black text-lg font-bold max-md:text-sm">
                {{ item?.part_desc || '-' }}
              </div>

              <!-- Unit Price -->
              <div class="text-text-caption text-base font-medium max-md:text-sm">
                {{ formatPrice(item?.unit_price) }}
              </div>

              <!-- Quantity -->
              <div class="text-text-caption text-sm font-medium max-md:text-xs">
                Qty:
                {{ item?.total_quantity ?? 0 }}
                {{ item?.uom || '' }}
              </div>

            </div>

            <!-- Item Information -->
            <div class="flex flex-col items-end gap-1 max-md:hidden">

              <!-- Item Amount -->
              <div class="text-black text-sm font-semibold">
                {{ formatPrice(item?.item_amount) }}
              </div>

              <!-- Invoice Status -->
              <!-- <div class="text-text-caption text-xs font-medium">
            {{ item?.invoice_status || '-' }}
          </div> -->

            </div>

            <!-- Payment Failed / Aborted Message -->
            @if (
            order.status === "Payment Failed" ||
            order.status === "aborted"
            ) {
            <div class="flex items-center gap-2 text-[#E30613] text-[16px] font-bold max-md:text-base" *ngIf="
              item?.is_cancelled === true ||
              item?.is_return === true
            ">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="20" height="20">
                <circle cx="16" cy="16" r="14" fill="none" stroke="red" stroke-width="2" />

                <rect x="15" y="8" width="2" height="12" rx="1" fill="red" />

                <circle cx="16" cy="23" r="2" fill="red" />
              </svg>

              <span>
                This part is no longer available for purchase.
              </span>
            </div>
            }

          </div>

          <!-- Mobile Item Amount / Status -->
          <!-- <div *ngFor="let item of getInvoiceDetails(order)"
            class="hidden max-md:flex w-full justify-between items-center border-t border-gray-100 pt-2 mt-1">
            <div class="text-text-caption text-xs">
              Status:
              <span class="text-black font-semibold">
                {{ item?.invoice_status || '-' }}
              </span>
            </div>

            <div class="text-black text-sm font-semibold">
              {{ formatPrice(item?.item_amount) }}
            </div>
          </div> -->

        </ng-template>

        <!-- Payment Failed / Aborted Footer -->
        <div class="border-t border-gray-200 w-full mt-4 mb-2" *ngIf="
        order.status === 'Payment Failed' ||
        order.status === 'aborted'
      ">
          <div class="flex flex-wrap justify-between items-center
               text-text-caption text-base font-medium
               max-md:text-sm mt-2 mb-2 gap-6">

            <!-- Order Total -->
            <div>
              Order Total: {{ formatBookingAmount(getOrderTotal(order)) }}
            </div>

            <!-- Actions -->
            <div class="flex flex-wrap gap-4">

              <!-- Move To Cart -->
              <div>
                <button type="button" class="text-primary-deep-blue text-sm
                     border border-primary-deep-blue
                     rounded-md px-2 py-1 font-bold
                     hover:underline" (click)="moveToCart(order)">
                  Move To Cart
                </button>
              </div>

              <!-- Retry Payment -->
              <div>
                <button type="button" [disabled]="!retryPaymentMethod(order)" class="text-primary-deep-blue text-sm
                     border border-primary-deep-blue
                     rounded-md px-2 py-1 font-bold
                     hover:underline
                     disabled:opacity-50
                     disabled:cursor-not-allowed
                     disabled:hover:no-underline" (click)="initiatePayment(order)">
                  Retry Payment
                </button>
              </div>

            </div>

          </div>
        </div>

      </div>
    </div>
  </div>

  <!-- No Results Message -->
  <div *ngIf="!isLoading && (!orders || orders.length === 0 || !filteredOrders || filteredOrders.length === 0)"
    class="w-full text-center py-12 px-4 flex flex-col items-center justify-center bg-white rounded-lg border border-dashed border-[#D4D4D4] my-2">

    <div class="text-gray-800 text-lg font-bold mb-1">
      {{
      selectedTab === "booking"
      ? "No Bookings Found"
      : selectedTab === "enquiry"
      ? "No Enquiries Found"
      : "No Orders Found"
      }}
    </div>
    <div class="text-gray-500 text-sm max-w-md">
      {{
      (selectedOrderStatuses.length > 0 || selectedTimeFilter || searchTerm)
      ? "No results matching your selected filters. Try resetting or adjusting your search criteria."
      : (selectedTab === 'booking' ? 'You have no bookings yet.' : selectedTab === 'enquiry' ? 'You have no enquiries
      yet.' : 'You have no orders yet.')
      }}
    </div>

  </div>


  <div class="w-full flex justify-center relative my-4" *ngIf="orders?.length > 0 && filteredOrders?.length > 0">
    <!-- Pagination -->
    <app-pagination [currentPage]="currentPageValue" [totalPages]="totalPagesValue" [isVisible]="showPagination"
      (pageChange)="handlePageChange($event)">
    </app-pagination>
  </div>

  <!-- <app-loader *ngIf="loaderService "></app-loader> -->

  <div *ngIf="showRatingPopup" class="fixed inset-0 z-50 flex items-end justify-end md:items-end md:justify-end"
    (click)="toggleRatingPopup()">
    <!-- Backdrop -->
    <div class="absolute inset-0 bg-black bg-opacity-50 popup-backdrop" (click)="toggleRatingPopup()"></div>

    <!-- Popup Content -->
    <div
      class="relative w-full h-screen md:w-96 md:h-screen bg-white shadow-2xl overflow-hidden rating-popup flex flex-col rounded-t-3xl md:rounded-none"
      (click)="$event.stopPropagation()">
      <!-- Header -->
      <div class="p-4 md:p-6 border-b border-gray-200 flex justify-between items-center">
        <h2 class="text-xl md:text-2xl font-bold text-primary-deep-blue">
          Rate the order
        </h2>
        <button (click)="toggleRatingPopup()" class="text-gray-500 hover:text-gray-700">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>

      <!-- Content -->
      <div class="p-4 md:p-6 flex flex-col gap-6 flex-1 overflow-y-auto">
        <!-- Rating Section -->
        <div class="flex flex-col gap-2">
          <p class="text-base font-bold text-gray-800">
            Rate your shopping experience
          </p>
          <div class="flex items-center gap-4">
            <!-- Emoji 1 -->
            <button (click)="selectRating(1)" class="
                size-14 flex justify-center items-center rounded-full">

              <svg width="47" height="47" viewBox="0 0 47 47" [attr.fill]="selectedRating === 1 ? '#E53935' : '#D4D4D4'"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M46.6667 23.3333C46.6667 36.22 36.22 46.6667 23.3333 46.6667C10.4467 46.6667 0 36.22 0 23.3333C0 10.4467 10.4467 0 23.3333 0C36.22 0 46.6667 10.4467 46.6667 23.3333Z"
                  [attr.fill]="selectedRating === 1 ? '#E53935' : '#D4D4D4'" />
                <path
                  d="M30.334 32.6666C30.334 32.6666 28.0007 30.3332 23.334 30.3332C18.6673 30.3332 16.334 32.6666 16.334 32.6666M11.6445 23.0725C13.5705 23.9175 17.0174 23.3098 18.5382 21.8569M28.1298 21.8568C29.6506 23.3096 33.0974 23.9174 35.0234 23.0723"
                  stroke-width="2.33333" stroke-linecap="round" stroke-linejoin="round" stroke="black" />
              </svg>
            </button>

            <!-- Emoji 2 -->
            <button (click)="selectRating(2)" [class]="
                'size-14 flex justify-center items-center rounded-full ' +
                (selectedRating === 2
                  ? 'border-2'
                  : '')
              ">

              <svg width="56" height="56" viewBox="0 0 56 56" [attr.fill]="selectedRating === 2 ? '#FFEB3B' : '#D4D4D4'"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M51.3327 28C51.3327 40.8866 40.886 51.3333 27.9993 51.3333C15.1127 51.3333 4.66602 40.8866 4.66602 28C4.66602 15.1133 15.1127 4.66663 27.9993 4.66663C40.886 4.66663 51.3327 15.1133 51.3327 28Z"
                  [attr.fill]="selectedRating === 2 ? '#FFEB3B' : '#D4D4D4'" />
                <path
                  d="M20.2217 22.1667C21.5102 22.1667 22.5555 23.2112 22.5557 24.4998C22.5557 25.7884 21.5103 26.8337 20.2217 26.8337C18.9332 26.8336 17.8887 25.7883 17.8887 24.4998C17.8888 23.2113 18.9333 22.1669 20.2217 22.1667ZM35.7773 22.1667C37.0659 22.1667 38.1112 23.2112 38.1113 24.4998C38.1113 25.7884 37.066 26.8337 35.7773 26.8337C34.4888 26.8336 33.4443 25.7883 33.4443 24.4998C33.4445 23.2113 34.4889 22.1669 35.7773 22.1667Z"
                  fill="black" />
                <path d="M35 37.3335H21" stroke-width="2.33333" stroke-linecap="round" stroke-linejoin="round"
                  stroke="black" />
              </svg>


            </button>

            <!-- Emoji 3 -->
            <button (click)="selectRating(3)" [class]="
                'size-14 flex justify-center items-center rounded-full ' +
                (selectedRating === 3
                  ? 'border-2'
                  : '')
              ">

              <svg width="56" height="56" viewBox="0 0 56 56" [attr.fill]="selectedRating === 3 ? '#36B548' : '#D4D4D4'"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M51.3327 28C51.3327 40.8866 40.886 51.3333 27.9993 51.3333C15.1127 51.3333 4.66602 40.8866 4.66602 28C4.66602 15.1133 15.1127 4.66663 27.9993 4.66663C40.886 4.66663 51.3327 15.1133 51.3327 28Z"
                  [attr.fill]="selectedRating === 3 ? '#36B548' : '#D4D4D4'" />
                <path
                  d="M16.3316 23.3335C17.4983 17.5002 22.1649 17.5002 23.3316 23.3335M32.6649 23.3335C33.8316 17.5002 38.4982 17.5002 39.6649 23.3335M27.9983 42.0002C21.9026 42.0002 16.7168 38.1044 14.7949 32.6668C14.7949 32.6668 23.3316 33.8335 27.9983 33.8335C32.665 33.8335 41.2017 32.6668 41.2017 32.6668C39.2798 38.1044 34.094 42.0002 27.9983 42.0002Z"
                  stroke-width="2.33333" stroke-linecap="round" stroke-linejoin="round" stroke="black" />
              </svg>


            </button>

            <span class="text-[16px] font-bold text-primary-deep-blue">
              {{
              selectedRating === 1
              ? "Poor"
              : selectedRating === 2
              ? "Good"
              : selectedRating === 3
              ? "Excellent"
              : ""
              }}
            </span>
          </div>
        </div>

        <!-- Chips Section -->
        <div class="flex flex-col gap-2">
          <p class="text-base font-bold text-gray-800">
            {{ getCurrentFeedbackData().question }}
          </p>

          <div class="flex flex-wrap gap-2">
            <button *ngFor="let chip of getCurrentFeedbackData().chips" (click)="toggleChip(chip)" [ngClass]="
        isChipSelected(chip)
          ? 'border border-blue-500 bg-blue-50 text-blue-600'
          : 'border border-gray-300 bg-white text-gray-800'
      " class="rounded-lg px-3 py-2 text-sm font-medium transition-colors duration-200">
              {{ chip }}
            </button>
          </div>
        </div>

        <!-- Review Section -->
        <div class="flex flex-col gap-1">
          <p class="text-base font-bold text-gray-800">Submit your Review</p>
          <textarea [(ngModel)]="reviewComment" rows="4"
            class="w-full p-3 border border-gray-300 rounded-lg text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-primary-deep-blue"
            placeholder="Any other comment which you want to highlight."></textarea>
        </div>
      </div>

      <!-- Footer -->
      <div class="p-4 md:p-6 border-t border-gray-200 flex gap-3 flex-shrink-0">
        <button (click)="toggleRatingPopup()"
          class="flex-1 px-4 py-2 border border-primary-deep-blue text-primary-deep-blue rounded-lg font-bold transition-colors">
          Cancel
        </button>
        <button (click)="submitRating()"
          class="flex-1 px-4 py-2 bg-primary-deep-blue text-white rounded-lg font-bold hover:bg-primary-deep-blue/90 transition-colors">
          Submit
        </button>
      </div>
    </div>
  </div>
</div>